module.exports = __webpack_public_path__ + "img/028-puerto-rico.5d31dcaf.svg";